import { Box, Divider, Paper, Typography } from "@mui/material";
import NumericLabel from "react-pretty-numbers";

// Display-only: formula, expression, penalty_amount and total_amount come from the API's calculation_details_preview as-is (no calculation here)
const PenaltyCalculationPreview = ({ invoice }) => {
  const preview = invoice?.calculation_details_preview;
  // Same currency formatting as the invoice items Total Amount (AInvItems)
  const currencyParams = { locales: "en-GB", currency: true, currencyIndicator: invoice?.currency?.code ? invoice?.currency?.code : invoice?.currency, precision: 2, commafy: true, justification: "L" };
  return (
    <Paper elevation={0} sx={{ border: "1px solid #b7cce3", borderRadius: "8px", px: 1.5, py: 1, backgroundColor: "#edf3fa" }}>
      <Typography sx={{ fontSize: "15px", fontWeight: 800, color: "#1f3f68", mb: 0.5 }}>Calculation Details Preview</Typography>
      <Typography sx={{ fontSize: "13px", color: "#2f3b52" }}>Formula:</Typography>
      <Box sx={{ pl: 2 }}>
        <Typography sx={{ fontSize: "13px", color: "#62779a", mt: 0.25 }}>{preview?.formula || "--"}</Typography>
        <Typography sx={{ fontSize: "13px", color: "#2f3b52", mt: 0.25 }}>{preview?.expression || "--"}</Typography>
      </Box>
      <Divider sx={{ my: 0.75, borderColor: "#c6d7ea" }} />
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography sx={{ fontSize: "13px", color: "#62779a" }}>Penalty Amount (rounded — final invoice only)</Typography>
        <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#24364d" }}>{preview?.penalty_amount ? <NumericLabel params={currencyParams}>{preview.penalty_amount}</NumericLabel> : "--"}</Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} mt={0.25}>
        <Typography sx={{ fontSize: "14px", color: "#2f3b52" }}>Total Amount (Overdue Amount + Penalty)</Typography>
        <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#1f3f68", lineHeight: 1.3 }}>{preview?.total_amount ? <NumericLabel params={currencyParams}>{preview.total_amount}</NumericLabel> : "--"}</Typography>
      </Box>
    </Paper>
  );
};

export default PenaltyCalculationPreview;
